import { useState, useEffect, useRef } from "react";
import Logo from "../../assets/img/logo.png";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader"
import { axiosReq } from "../../commons/axiosReq";
// import { "https://assistant.bordarna.ir/" } from "../../commons/inFormTypes";
import Cookies from 'universal-cookie';
import VoiceIcon from "../../assets/icon/VoiceIcon";
import ActiveVoiceIcon from "../../assets/icon/ActiveVoiceIcon";
import AudioWave from "../../assets/img/wave.png";

const MainPage = () => {
    const [username, setUsername] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [snipper, setSnipper] = useState(false);

    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const chatRef = useRef(null);
    const [isStreaming, setIsStreaming] = useState(false);
    const audioChunksRef = useRef([]); // Stores recorded audio chunks
    const mediaRecorderRef = useRef(null); // MediaRecorder instance
    const websocketRef = useRef(null); // WebSocket instance
    const cookies = new Cookies();

    const wsUrl = "wss://assistant.bordarna.ir/voice_chat?name=" + cookies.get('name2'); // WebSocket server URL

    const toggleStreaming = async () => {
        if (isStreaming) {
            // Stop recording and WebSocket connection
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                mediaRecorderRef.current.stop();
                setIsStreaming(false);
                console.log("Streaming stopped.");
            }
            //if (websocketRef.current) {
            //    websocketRef.current.close();
            //}
            setIsStreaming(false);
            console.log("Streaming stopped.");
        } else {
            // Start recording and WebSocket connection
            try {
                setSnipper(true)
                websocketRef.current = new WebSocket(wsUrl);
                setIsStreaming(true);

                console.log(websocketRef.current)
                websocketRef.current.onopen = () => {
                    console.log("WebSocket connection opened.");
                    setSnipper(true)

                    setIsStreaming(true);
                };

                websocketRef.current.onmessage = (event) => {
                    console.log("WebSocket connection onmessage.");

                    const serverResponse = JSON.parse(event.data);
                    console.log(8888);
                    console.log(serverResponse);

                    if (serverResponse.type === "conversation") {
                        // Handle conversation messages
                        console.log(999);
                        console.log(999);
                        setSnipper(false)
                        setMessages((prevMessages) => [
                            ...prevMessages,
                            // { text: serverResponse.prompt, sender: "user" },
                            { text: <img className="w-full h-[40px]" src={AudioWave} alt=""/>
                            ,sender:"user"},
                            { text: serverResponse.answer, sender: "bot" }
                        ]);
                        // setMessages((prevMessages) => [...prevMessages, { text: chunk.replace(/(\r\n|\n|\r)/gm, ""), sender: "bot" }]);

                    }
                    else if (serverResponse.type === "audio") {
                        // Handle audio chunks

                        const decodedChunk = new Uint8Array(
                            atob(serverResponse.data)
                                .split("")
                                .map((char) => char.charCodeAt(0))
                        );
                        audioChunksRef.current.push(decodedChunk);

                    }
                    else if (serverResponse.type === "text") {
                        playAudioChunks();
                    }
                    return false;
                };

                websocketRef.current.onclose = () => {
                    setSnipper(false)

                    console.log("WebSocket connection closed.");
                    setIsStreaming(false);
                };

                websocketRef.current.onerror = (error) => {
                    setSnipper(false)

                    console.error("WebSocket error:", error);
                    setIsStreaming(false);
                };

                // Request microphone access
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                const recorder = new MediaRecorder(stream);
                mediaRecorderRef.current = recorder;
                setSnipper(false)

                // Capture audio data chunks
                recorder.ondataavailable = (e) => {
                    audioChunksRef.current.push(e.data);
                };

                // When recording stops, save audio and send file path to server
                recorder.onstop = async () => {
                    const blob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
                    audioChunksRef.current = []; // Clear chunks after saving

                    // Save the audio file locally and send its path to the server
                    const fileurl = await CreateUrl(blob, "arshia.mp3");
                    console.log("Audio saved at:", fileurl);

                    if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
                        websocketRef.current.send(JSON.stringify({ file_url: fileurl }));
                        console.log("Sent audio file path to the server.");
                    }
                };

                // Start recording
                recorder.start();
                console.log("Audio recording started.");
            } catch (error) {
                console.error("Error starting streaming:", error);
            }
        }
    };

    const CreateUrl = async (blob, fileName) => {
        const file = new File([blob], fileName, { type: "audio/mp3" });
        console.log(222)
        console.log(file)
        const formData = new FormData();
        formData.append("FileDetails", file)
        // Create a downloadable link for the file
        // const link = document.createElement("a");
        // link.href = URL.createObjectURL(file);
        // link.download = fileName;
        // link.click();

        const dataFile = await axios.post("https://api.bordarna.ir/api/" + "Article/UploadPhoto2", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
            ,
        });
        if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {
            // const pieces = dataFile?.data?.split('/')
            console.log(dataFile?.data)
            return ("https://api.bordarna.ir/uploads/" + dataFile?.data)
            // props.setFiles(true)
        }
        else {
            console.log(dataFile)
            return "false";
        }


        // Return the path (if needed for further use)
        // return `"C:\\Users\\ASUS\\Downloads"${fileName}.mp3`;
    };

    const playAudioChunks = () => {
        setSnipper(false)
        if (audioChunksRef.current.length === 0) {
            console.log("No audio chunks to play.");
            return;
        }

        const audioBuffer = new Blob(audioChunksRef.current, { type: "audio/mp3" });
        const audioUrl = URL.createObjectURL(audioBuffer);
        const audio = new Audio(audioUrl);

        audio.onended = () => {
            console.log("Audio playback finished.");
            audioChunksRef.current = []; // Clear chunks after playing
        };

        audio.play();
    };

    useEffect(() => {
        // Cleanup when component unmounts
        return () => {
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                mediaRecorderRef.current.stop();
            }
            if (websocketRef.current) {
                websocketRef.current.close();
            }
        };
    }, []);
    const handleLogin = () => {
        if (username.trim() !== "") {
            setIsLoggedIn(true);
            setMessages([{ text: `سلام ${username}! چطور می‌تونم کمکتون کنم؟`, sender: "bot" }]);
        }
    };

    const sendMessage = async () => {
        setSnipper(true)
        if (message.trim() === "") return;
        // setMessages((prevMessages) => [...prevMessages, { text:  <img className="w-full h-[40px]" src={AudioWave} alt=""/>, sender: "user" }]);
        setMessages((prevMessages) => [...prevMessages, { text:message, sender: "user" }]);
        setMessage("");
        const cookies = new Cookies();

        const dataFile = await axios.post("https://assistant.bordarna.ir/" + "chat", {
            prompt: message
        },
            {
                headers: {
                    Authorization: `Bearer ${cookies.get('token2')}`,
                    "Content-Type": "application/json",
                    'X-Frame-Options': 'Deny',
                    'X-Content-Type-Options': "nosniff",
                    'X-XSS-Protection': "1; mode=block",
                    "Referrer-Policy": "same-origin",
                    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload"
                }
                , onDownloadProgress: progressEvent => {
                    const chunk = progressEvent.event.target.responseText;

                    console.log(55)
                    console.log(progressEvent)
                    console.log(chunk.replace(/(\r\n|\n|\r)/gm, ""))
                    setMessages((prevMessages) => [...prevMessages, { text: chunk.replace(/(\r\n|\n|\r)/gm, ""), sender: "bot" }]);

                    // dataChunk contains the data that have been obtained so far (the whole data so far).. 
                    // So here we do whatever we want with this partial data.. 
                    // In my case I'm storing that on a redux store that is used to 
                    // render a table, so now, table rows are rendered as soon as 
                    // they are obtained from the endpoint.
                    return new Promise((resolve) => setTimeout(resolve, 100));
                }
            },);
        if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {

            // console.log(123)
            // console.log(dataFile.data)
            // setMessages((prevMessages) => [...prevMessages, { text: dataFile.data, sender: "bot" }]);
            setSnipper(false)
        }
        else {
            console.log(dataFile)
            setSnipper(false)

            alert("ارتباط برقرار نشد ");
        }
        //setTimeout(() => {
        //    const responses = [
        //        "سلام! چطور میتونم کمکتون کنم؟",
        //        "متوجه نشدم، لطفا بیشتر توضیح بدید.",
        //        "خیلی جالبه! لطفا ادامه بدید.",
        //        "برای اطلاعات بیشتر به سایت بانک سپه مراجعه کنید."
        //    ];
        //    const randomResponse = responses[Math.floor(Math.random() * responses.length)];
        //    setMessages((prevMessages) => [...prevMessages, { text: randomResponse, sender: "bot" }]);
        //}, 1000);
    };

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages]);

    return (
        <div className="h-screen flex justify-center items-center bg-gray-100 hasBackgroud">
            {/*{!isLoggedIn ? (
                <div className="bg-white w-[70%] max-w-[400px] rounded-xl p-6 shadow-lg flex flex-col items-center">
                    <img src={Logo} className="w-[80px] mb-4" alt="logo" />
                    <h2 className="text-[15px] font-IRANYekanExtra mb-2">به دستیار هوشمند بانک سپه خوش آمدید!</h2>
                    <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">لطفا نام خود را وارد کنید:</p>
                    <input
                        className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF"
                        type="text"
                        placeholder="نام خود را وارد کنید"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <button
                        className="bg-[#f4752a] w-full font-IRANYekanExtra text-white px-4 py-2 rounded-lg mt-4"
                        onClick={handleLogin}
                    >
                        ورود
                    </button>
                </div>
            ) : (*/}
            <div className="bg-white w-[70%] lg:w-[95%] max-w-[500px] rounded-xl h-[570px] shadow-lg flex flex-col relative">
                <div className="h-[70px] bg-[#ffe6b6] w-full rounded-t-xl flex items-center myShadow py-2 px-5">
                    <div className="w-[55px] h-[55px] bg-white rounded-full flex items-center justify-center">
                        {/* <img src={Logo} className="w-[80%] block mx-auto" alt="logo" /> */}
                    </div>
                    <span className="font-IRANYekanExtra text-[#000] text-[15px] mr-4">
                        دستیار هوشمند 
                    </span>
                </div>
                <div className="h-[450px] overflow-y-auto p-4 flex flex-col" id="chatBack" ref={chatRef}>
                <div
                            key={0}
                            className={`p-2 rounded-lg max-w-[70%] mb-2 font-IRANYekanNormal relative ${ "bg-[#f3f3f3] text-[#000] mr-auto"}`}
                        >
                            <p>سلام، من دستیار هوشمند هستم. در خدمت شما هستم تا پاسخگوی سوالات شما باشم.</p>

                            </div>
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            className={`p-2 rounded-lg max-w-[70%] mb-2 font-IRANYekanNormal relative ${msg.sender === "user" ? "bg-[#dfe9ff] text-[#000] ml-auto" : "bg-[#f3f3f3] text-[#000] mr-auto"}`}
                        >
                            {msg.text}

                            </div>
                    ))
                    }
                    {
                        snipper ?
                            <ClipLoader
                                color={"#000"}
                                loading={snipper}
                                size={50}
                                aria-label={"loading spinner"}
                                data-testid="loader"

                            />
                            : null}

                </div>
                <div className="bg-white h-[50px] w-full absolute bottom-0 rounded-b-xl bottomShadow flex items-center py-2 px-4">
                    <input
                        className="border-none w-[95%] ml-2 font-IRANYekanMedium outline-none"
                        type="text"
                        placeholder="پیام خود را بنویسید ..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                    />
                    <div className="flex justify-end">
                        {isStreaming ?
                            <button className="flex justify-end" onClick={toggleStreaming}>
                                <ActiveVoiceIcon />
                            </button>

                            :
                            <button className="flex justify-end" onClick={toggleStreaming}>
                                <VoiceIcon />
                            </button>
                        }
                        <button className="flex justify-end mr-2" onClick={sendMessage}>
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M25.0613 2.67905C25.1616 2.27899 25.145 1.85855 25.0135 1.46765C24.8819 1.07674 24.641 0.731798 24.3192 0.473773C23.9974 0.215748 23.6084 0.0554825 23.1982 0.0120067C22.7881 -0.0314691 22.3741 0.0436715 22.0054 0.228506L1.19275 10.6348C0.834394 10.8136 0.532959 11.0888 0.322271 11.4294C0.111582 11.77 -2.67029e-05 12.1625 -2.67029e-05 12.563C-2.67029e-05 12.9635 0.111582 13.3561 0.322271 13.6966C0.532959 14.0372 0.834394 14.3124 1.19275 14.4912L22.0054 24.8975C22.3741 25.0823 22.7881 25.1575 23.1982 25.114C23.6084 25.0705 23.9974 24.9103 24.3192 24.6522C24.641 24.3942 24.8819 24.0493 25.0135 23.6584C25.145 23.2675 25.1616 22.847 25.0613 22.447L22.8818 13.7316L10.226 12.563L22.8818 11.3944L25.0613 2.67905Z"
                                    fill="#3452A4"
                                />
                            </svg>
                        </button>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default MainPage;


// return (
//     <div>
//         <h1>Audio Streamer</h1>
//         <button onClick={toggleStreaming}>
//             {isStreaming ? "Stop Streaming" : "Start Streaming"}
//         </button>
//         <div>
//             <h3>Messages from Server:</h3>
//             <ul>
//                 {messages.map((msg, index) => (
//                     <li key={index}>{msg}</li>
//                 ))}
//             </ul>
//         </div>
//     </div>
// );